import React, { Component } from "react";
import PropTypes from "prop-types";
import IGetCommissionTiersDTO from "../../../../models/DTO/IGetCommissionTiersDTO";
import IOnGetCommissionTiersDTO from "../../../../models/DTO/IOnGetCommissionTiersDTO";
import IOnUpdateCommissionTiersDTO from "../../../../models/DTO/IOnUpdateCommissionTiersDTO";
import IUpdateCommissionTiersDTO from "../../../../models/DTO/IUpdateCommissionTiersDTO";
import ICommission_Tiers from "../../../../models/ICommission_Tiers";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import IVendorModel from "../../../../models/IVendorModel";
import { LoadingResults } from "../../../shared/LoadingResults/LoadingResults";
import NoResults from "../../../shared/NoResults/NoResults";
import OwButton from "../../../shared/OwButton/OwButton";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import CommissionTierRow from "./CommissionTierRow/CommissionTierRow";
import { Socket } from "socket.io-client";

type Props = {
    toggleSidebar: (shouldBeVisible?: boolean, refreshData?: boolean) => void;
    socket: Socket;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
};

type State = {
    commissionTiers: ICommission_Tiers[];
    disableSave: boolean;
    activeSave: boolean;
    resultsLoaded: boolean;
};

class CommissionTierSidebar extends Component<Props, State> {
    readonly state: State = {
        commissionTiers: [],
        disableSave: false,
        activeSave: false,
        resultsLoaded: false,
    };

    componentDidMount(): void {
        this.props.socket.on("onGetCommissionTiers", this.onGetCommissionTiers);
        this.props.socket.on("onUpdateCommissionTiers", this.onUpdateCommissionTiers);

        this.getCommissionTiers();
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener("onGetCommissionTiers", this.onGetCommissionTiers);
        this.props.socket.removeListener("onUpdateCommissionTiers", this.onUpdateCommissionTiers);
    }

    getCommissionTiers = () => {
        this.setState(
            {
                resultsLoaded: false,
            },
            () => {
                const payload: IGetCommissionTiersDTO = {
                    userGuid: this.props.userModel.guid,
                    userToken: this.props.userModel.token,
                    supplierGuid: this.props.supplierModel.guid,
                };

                this.props.socket.emit("getCommissionTiers", payload);
            }
        );
    };

    onGetCommissionTiers = (data: IOnGetCommissionTiersDTO) => {
        this.setState({
            commissionTiers: data.commissionTiers,
            resultsLoaded: true,
        });
    };

    onUpdateCommissionTiers = (data: IOnUpdateCommissionTiersDTO) => {
        // refresh the commission tiers.
        this.cancel(true);
    };

    cancel = (refreshData?: boolean) => {
        this.props.toggleSidebar(false, refreshData);
    };

    updateTierData = (tier: ICommission_Tiers, index: number) => {
        const commissionTiers = [...this.state.commissionTiers];

        commissionTiers[index] = tier;

        this.setState({
            commissionTiers,
        });
    };

    saveTiers = () => {
        const payload: IUpdateCommissionTiersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            commissionTiers: this.state.commissionTiers,
        };

        this.props.socket.emit("updateCommissionTiers", payload);
    };

    addCommissionTier = () => {
        // show a new row to add.
        const newCommissionTier: Partial<ICommission_Tiers> = {
            percent: 0,
            sequence: 1,
        };

        const commissionTiers = [...this.state.commissionTiers, newCommissionTier as ICommission_Tiers];

        this.setState({
            commissionTiers,
        });
    };

    render() {
        const resultsLoaded = this.state.resultsLoaded;
        const noResults = this.state.resultsLoaded && !this.state.commissionTiers.length;

        let commissionTiers: any = <LoadingResults />;

        if (resultsLoaded) {
            if (noResults) {
                commissionTiers = <NoResults />;
            } else {
                commissionTiers = this.state.commissionTiers.map((tier: ICommission_Tiers, index: number) => {
                    return <CommissionTierRow key={index} tier={tier} updateTierDataFn={this.updateTierData} index={index} />;
                });
            }
        }

        return (
            <div className="CommissionSidebar p-3" style={{ height: "100vh", overflow: "hidden" }}>
                <div style={{ height: "15vh" }}>
                    <div className="text-end">
                        <button
                            className="btn btn-danger btn-sm"
                            onClick={() => {
                                this.cancel();
                            }}>
                            <i className="far fa-times" />
                        </button>
                    </div>
                    <OwTitle leftIconName={"fad fa-sack-dollar"} title={"commissions"} />
                    <hr />
                </div>
                <div className="PriceGroupForm pb-2" style={{ height: "85vh", overflowY: "scroll" }}>
                    <div className={"mb-2"}>
                        <OwButton fn={this.addCommissionTier} title={"add"} leftIconClass={"far fa-plus"} />
                    </div>
                    <div className={"mb-2"}>{commissionTiers}</div>

                    <div>
                        <OwButton
                            disabled={this.state.disableSave}
                            active={this.state.activeSave}
                            leftIconClass=""
                            className="btn-primary me-2"
                            title="save"
                            fn={this.saveTiers}
                        />

                        <OwButton
                            className={"btn-danger"}
                            fn={() => {
                                this.cancel();
                            }}
                            title={"cancel"}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default CommissionTierSidebar;
